<template>
  <div class="tgh-home tgh-page">
    <h4>KeTengah . DiTengah . DariTengah</h4>
    <b-carousel
      id="tgh-home-carousel"
      style="text-shadow: 0px 0px 2px #000"
      fade
      v-if="banner.length > 0"
    >
      <b-carousel-slide v-for="(ban,banIndex) in banner" :key="`ban-${banIndex}`">
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100"
            v-lazy="ban.photo"
          >
        </template>
      </b-carousel-slide>
    </b-carousel>
    <div class="tgh-blank" v-else></div>
    <AddressNav></AddressNav>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import AddressNav from '@/components/AddressNav.vue'
export default {
  name: 'Home',
  components: {
    AddressNav
  },
  data() {
    return {
      banner : []
    }
  },
  methods : {
    getBanner() {
      let vm = this
      let url = apiUrl+'/home/banner'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.banner = response.data.data
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    }
  },
  mounted() {
    this.getBanner()
  }
}
</script>
